export default {
  "i18n": {
    "chooseLang": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Change Language:"])},
    "languages": {
      "en": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["English"])},
      "ru": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Russian"])}
    },
    "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Language Changed"])}
  },
  "navBar": {
    "greeting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hello, "])},
    "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logout"])},
    "menuItems": {
      "create": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New Contact"])},
      "import": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Import Contacts"])},
      "export": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Export Contacts"])},
      "removeAll": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Remove All Contacts"])}
    }
  },
  "export": {
    "titleCSV": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["#,Name,Phone,Email,Birthday\n"])},
    "emptyList": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contacts list is empty."])},
    "plainText": {
      "index": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contact #"])},
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name: "])},
      "number": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Number: "])},
      "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email: "])},
      "birthday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Birthday: "])}
    }
  },
  "commonUI": {
    "copiedButton": {
      "toDoTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click to Copy to Clipboard"])},
      "doneTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copied to Clipboard"])}
    },
    "resultMessage": {
      "closeBtn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Close"])}
    },
    "dialog": {
      "closeBtn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])}
    }
  },
  "dialogs": {
    "create": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New Contact"])},
      "btnTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create"])}
    },
    "edit": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit Contact"])},
      "btnTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save Changes"])}
    },
    "createAndEdit": {
      "inputs": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
        "phone": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Phone Number"])},
        "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])},
        "birthday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Birthday"])},
        "birthdayTip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["If you manually enter an incomplete (dd.01.2000) or non-existent (February 31) date, the date will not be added"])}
      },
      "errors": {
        "nameRequired": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name is required."])},
        "longName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name must be less than 40 characters."])},
        "phoneRequired": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Phone number is required."])},
        "invalidPhone": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Phone must be valid."])},
        "invalidMail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail must be valid."])},
        "invalidDate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date must be valid"])},
        "earlyDate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The site rules prohibit saving users from the future"])},
        "lateDate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["We doubt that you will be able to reach such an old contact. Please, try someone younger"])}
      }
    },
    "import": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Import Contacts"])},
      "inputTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paste JSON Data here. Example:"])},
      "hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The 'name' and 'phone' properties are required"])},
      "btnTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Import"])},
      "errors": {
        "required": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JSON Data is required."])},
        "invalid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Data is invalid."])}
      }
    },
    "delete": {
      "one": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete Contact"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Are you sure you want to delete the Contact? <br /> This action cannot be changed"])},
        "btnTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yes, delete"])}
      },
      "all": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete All Contacts"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Are you sure you want to delete All Contacts? <br /> This action cannot be changed"])},
        "btnTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yes, delete"])}
      }
    }
  },
  "auth": {
    "inputs": {
      "mail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])},
      "password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password"])},
      "errors": {
        "fieldRequired": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This field is required."])},
        "emailInvalid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail must be valid."])}
      }
    },
    "buttons": {
      "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Login"])},
      "signUp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sign Up"])},
      "loginInstead": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Login Instead"])},
      "signUpInstead": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sign Up Instead"])}
    },
    "info": {
      "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Loading..."])},
      "logoutMessage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Goodbye!"])},
      "autoLogoutMessage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Your session has expired, log in again!"])},
      "success": {
        "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authorization was successful"])},
        "signUp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Registration was successful"])}
      },
      "errors": {
        "errorMessage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Failed to Authenticate! "])},
        "defaultMessage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please, try again later."])},
        "login": {
          "EMAIL_NOT_FOUND": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User record with this email not found."])},
          "INVALID_PASSWORD": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You entered incorrect password!"])},
          "USER_DISABLED": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The user account has been disabled by an administrator."])}
        },
        "signUp": {
          "EMAIL_EXISTS": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This email has been used already. Please, try another one"])},
          "TOO_MANY_ATTEMPTS_TRY_LATER": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["We have blocked all requests from this device due to unusual activity. Try again later."])}
        }
      }
    }
  },
  "onboarding": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Almost finished!"])},
    "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Do you want us to immediately add important contacts (ambulance, police)?"])},
    "addBtnTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add, Please"])},
    "noAddBtnTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No, Thanks"])},
    "action": {
      "defaultContacts": {
        "police": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Police"])},
        "fireDepartment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fire Department"])},
        "ambulance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ambulance"])},
        "emergencyNumber": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Emergency Number"])}
      },
      "error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An error occurred while adding important contacts"])}
    }
  },
  "contacts": {
    "toolbar": {
      "inputLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search a contact"])}
    },
    "emptyList": {
      "notFound": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["There's no such contact"])},
      "noContacts": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You haven't add any contacts yet"])},
        "createBtn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create manually"])},
        "btnsDevider": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["or"])},
        "autoaddBtn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add important contacts (ambulance, police)"])}
      }
    },
    "list": {
      "counterTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All contacts: "])},
      "item": {
        "info": {
          "phone": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Phone"])},
          "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
          "birthday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Birthday"])}
        },
        "buttons": {
          "call": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Call"])},
          "write": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Write"])}
        }
      }
    },
    "info": {
      "success": {
        "loaded": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contacts uploaded"])},
        "import": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Import completed. All contacts (", _interpolate(_named("count")), " pcs) have been imported."])},
        "create": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contact added"])},
        "delete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contact deleted"])},
        "deleteAll": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All Contacts deleted"])},
        "update": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contact updated"])}
      },
      "errors": {
        "loaded": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An error occurred while uploading contacts"])},
        "import": {
          "default": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An error occurred while importing contacts"])},
          "duplicate": {
            "all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["None of the contacts were imported. Probably, entered contacts already exist or they are recorded incorrectly"])},
            "partly": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Import completed. Part of contacts (", _interpolate(_named("issues")), " pcs) was not imported. Probably, entered contacts already exist or they are recorded incorrectly"])}
          }
        },
        "create": {
          "default": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An error occurred while creating new contact"])},
          "exist": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Such a contact already exists"])}
        },
        "delete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An error occurred while deleting contact"])},
        "deleteAll": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An error occurred while deleting contacts"])},
        "update": {
          "default": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An error occurred while updating contact"])},
          "exist": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Such a contact already exists"])}
        }
      }
    }
  },
  "notFound": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Page not found"])},
    "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This page doesn't exist yet"])},
    "linkStart": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maybe you wanna check"])},
    "linkEnd": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["contacts list?"])}
  }
}